import { useEffect, useState } from 'react';
import { List, ListItemText, ListItemButton } from '@mui/material';
import { useController } from 'react-hook-form';
import { ICourtViewModel } from 'viewModels';
import { useCourts } from '../../context/courts';
import { Container, MessageContainer } from './styles';

interface CourtListProps {
  districtId: string;
  disabled?: boolean;
  name: string;
  filterValue: string;
  control: any;
}

export function CourtList({
  districtId,
  disabled = false,
  name,
  filterValue,
  control,
}: CourtListProps) {
  const [filter, setFilter] = useState('');
  const {
    field: { onChange },
  } = useController({ name, control });
  const { courts, courtSelectedId, setCourtSelectedId, lastAddedCourtId } = useCourts();

  const handleSelectCourt = (court: ICourtViewModel) => {
    onChange(court.name);
    setCourtSelectedId(court.id);
  };

  const filteredCourts = courts.filter((court) =>
    court.name.toLowerCase().includes(filter.toLowerCase()),
  );

  useEffect(() => {
    if (lastAddedCourtId) {
      const newlyAddedCourt = courts.find((court) => court.id === lastAddedCourtId);
      if (newlyAddedCourt) {
        handleSelectCourt(newlyAddedCourt);
      }
    }
  }, [lastAddedCourtId, courts]);

  useEffect(() => {
    setFilter(filterValue);
    if (filterValue === '') {
      setCourtSelectedId('');
      onChange('');
    }
  }, [filterValue]);

  if (!districtId) {
    return (
      <MessageContainer>
        Selecione uma comarca existente para exibir as varas e juizados
      </MessageContainer>
    );
  }

  return (
    <Container>
      <div className="listContainer">
        <List disablePadding>
          {filteredCourts.map((court) => (
            <ListItemButton
              key={court.id}
              onClick={() => handleSelectCourt(court)}
              className={courtSelectedId === court.id ? 'selected' : ''}
            >
              <ListItemText primary={court.name} />
            </ListItemButton>
          ))}
        </List>
      </div>
    </Container>
  );
}
